import React from 'react';
import {useTranslation} from 'react-i18next';
// import {NavBar} from 'antd-mobile';
import DetailNavTitle from '@/components/business/detail-nav-title';
import {goBack} from '@/utils';
import styles from '../index.module.scss';

const GameRules = () => {
  const {t} = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <DetailNavTitle
        // hideTitle={true}
        serverRight
        hideAmount
        title={t('gameRules.title')}
        onBack={goBack}
      />

      <div className=" p-6 gap-6 flex flex-col">
        <h2 className={styles.title1}>{t('gameRules.tableOfContents')}</h2>

        <div className="flex flex-col gap-3">
          {[
            'generalTerms',
            'specialTerms',
            'cricket',
            'kabaddi',
            'TENNIS',
            'BASKETBALL',
            'VOLLEYBALL',
            'BEACH VOLLEYBALL, TABLE TENNIS, BADMINTON',
            'FOOTBALL',
            'E-SPORT',
          ].map(item => (
            <div key={item} className={styles.link}>
              • {t(`gameRules.menu.${item}`)}
            </div>
          ))}
        </div>
        <div>
          <section className="flex flex-col gap-3">
            <h3 className={styles.title2}>
              {t('gameRules.generalTerms.title')}
            </h3>
            <div>
              {[1, 2].map(num => (
                <p key={num} className={styles.content}>
                  {t(`gameRules.generalTerms.rule${num}`)}
                  {/* 加个换行 */}
                  <br />
                </p>
              ))}
            </div>
          </section>

          {/* 其他部分类似 */}
        </div>
      </div>
    </div>
  );
};

export default GameRules;
